import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import NewsList from '@/views/NewsList.vue';
import NewsDetail from '@/views/NewsDetail.vue';
import People from '@/views/People.vue';
import Portfolio from '@/views/Portfolio.vue';
import Services from '@/views/Services.vue';
import Enquiry from '@/views/Enquiry.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/portfolio',
        name: 'Portfolio',
        component: Portfolio,
    },
    {
        path: '/about',
        name: 'About',
        component: About,
    },
    {
        path: '/news',
        name: 'NewsList',
        component: NewsList,
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetail,
    },
    {
        path: '/people',
        name: 'People',
        component: People,
    },
    {
        path: '/services',
        name: 'Services',
        component: Services,
    },
    {
        path: '/enquiry',
        name: 'Enquiry',
        component: Enquiry,
    },
];

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

export default router;
